import { useSyncExternalStore } from "react";

// Kept in memory on purpose: it lasts across page changes in the app and
// resets when the browser is refreshed.
let isHiddenForSession = false;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = (): boolean => isHiddenForSession;

/** Hides every AdminReportInformation until the browser is refreshed */
export const hideAdminReportInformationForSession = (): void => {
  isHiddenForSession = true;
  listeners.forEach((listener) => listener());
};

/** Whether an admin chose "Hide all for session" (e.g. to screen share) */
export const useAdminReportInformationHiddenForSession = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, () => false);
